import { useCallback, useEffect, useState } from "react";
import { fetchCatalogCategories } from "../api/client.js";
import type { CatalogCategoriesResponse } from "../api/types.js";
import { messages } from "../i18n/messages.js";

export interface CatalogCategoriesState {
  loading: boolean;
  error: string | null;
  data: CatalogCategoriesResponse | null;
  retry: () => void;
}

export function useCatalogCategories(): CatalogCategoriesState {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<CatalogCategoriesResponse | null>(null);
  const [reloadToken, setReloadToken] = useState(0);

  const retry = useCallback(() => {
    setReloadToken((value) => value + 1);
  }, []);

  useEffect(() => {
    let cancelled = false;

    void (async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetchCatalogCategories();
        if (!cancelled) {
          setData(response);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : messages.catalog.catalogFailed);
          setData(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [reloadToken]);

  return { loading, error, data, retry };
}
